module.exports = __webpack_public_path__ + "static/img/contact_banner.03be29f7.png";